;window.pa = window.pa || {};
window.pa.helper = (function () {

	'use strict';

	function ProjectsAbroadHelper() {

		var global = {};

		var fn = {

			/**
			 * @see https://davidwalsh.name/javascript-debounce-function
			 * Originally from _.js
			 */
			debounce: function (func, wait, immediate) {
				var timeout;
				return function () {
					var context = this, args = arguments;
					var later = function () {
						timeout = null;
						if (!immediate) func.apply(context, args);
					};
					var callNow = immediate && !timeout;
					clearTimeout(timeout);
					timeout = setTimeout(later, wait);
					if (callNow) func.apply(context, args);
				};
			},

			canPositionSticky: function ()
			{
				if (window.CSS && CSS.supports) {
					return CSS.supports('position', 'sticky');
				}
				else {
					var elm = document.createElement('div');
					elm.style.position = 'sticky';
					// If the browser does not support the property, it will not be set
					return elm.style.position === 'sticky';
				}
			},

			checkWindowWidth: function (width) {
				// Check window width (scrollbar included)
				var e = window,
					a = 'inner';

				if (!('innerWidth' in window)) {
					a = 'client';
					e = document.documentElement || document.body;
				}

				return (e[a + 'Width'] >= width);
			},
		};

		return {
			debounce: fn.debounce,
			canPositionSticky: fn.canPositionSticky,
			checkWindowWidth: fn.checkWindowWidth,
		}
	}

	return new ProjectsAbroadHelper();

}());
